module.exports = __webpack_public_path__ + "img/987e1ce.jpg";